export default __webpack_public_path__ + "icon_calendar.915e8f6f02096526f3f062febf151eb8.svg";